import { createAction, handleActions } from 'redux-actions';

const setSorting = createAction("SCREENS/ESTIMATES/SET_SORTING");

const defaultState = {
  columnKey: 'reference',
  order: 'descend'
};

const reducer = handleActions(
  {
    [setSorting]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setSorting, reducer };